import React from 'react';
import { Heart, Award, Star } from 'lucide-react';
import { aboutText, salonInfo } from '../data/mock';

export const AboutSection = () => {
  return (
    <section id="about" className="relative overflow-hidden bg-white py-24">
      {/* Decorative elements */}
      <div className="absolute -left-40 top-20 h-80 w-80 rounded-full bg-neutral-100 blur-3xl" />
      <div className="absolute -right-40 bottom-20 h-80 w-80 rounded-full bg-[#d4af37]/5 blur-3xl" />

      {/* Gold accent line */}
      <div className="absolute left-0 top-0 h-full w-px bg-gradient-to-b from-transparent via-[#d4af37]/30 to-transparent" />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid items-center gap-16 lg:grid-cols-2">
          {/* Image Column */}
          <div className="relative">
            <div className="relative">
              {/* Main Image */}
              <div className="relative overflow-hidden rounded-2xl shadow-2xl border border-neutral-200">
                <img
                  src="https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?auto=format&fit=crop&w=800&q=80"
                  alt="Interior del spa"
                  className="aspect-[4/5] w-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
              </div>
              
              {/* Floating Card */}
              <div className="absolute -bottom-8 -right-8 rounded-xl bg-neutral-900 p-6 shadow-xl md:-right-12 border border-[#d4af37]/20">
                <div className="flex items-center gap-4">
                  <div className="flex h-14 w-14 items-center justify-center rounded-full bg-[#d4af37]/20">
                    <Heart className="h-7 w-7 text-[#d4af37]" fill="currentColor" />
                  </div>
                  <div>
                    <p className="text-2xl font-bold text-white">+500</p>
                    <p className="text-sm text-neutral-400">Clientas felices</p>
                  </div>
                </div>
              </div>

              {/* Decorative gold accent */}
              <div className="absolute -left-4 -top-4 h-24 w-24 rounded-full border-4 border-[#d4af37]/30" />
            </div>
          </div>

          {/* Content Column */}
          <div className="lg:pl-8">
            {/* Section Badge */}
            <div className="mb-4 inline-flex items-center gap-2 rounded-full bg-[#d4af37]/10 px-4 py-1.5 text-sm font-medium text-[#d4af37] border border-[#d4af37]/20">
              <Star className="h-4 w-4" />
              Sobre Nosotros
            </div>

            {/* Title */}
            <h2 className="font-serif text-3xl font-bold text-neutral-800 sm:text-4xl lg:text-5xl">
              {aboutText.title}
            </h2>

            {/* Decorative line */}
            <div className="my-6 flex items-center gap-3">
              <div className="h-1 w-16 rounded-full bg-gradient-to-r from-[#d4af37] to-[#b8860b]" />
              <div className="h-2 w-2 rounded-full bg-[#d4af37]" />
            </div>

            {/* Description */}
            <div className="space-y-4">
              {aboutText.paragraphs.map((paragraph, index) => (
                <p key={index} className="text-lg leading-relaxed text-neutral-600">
                  {paragraph}
                </p>
              ))}
            </div>

            {/* Features */}
            <div className="mt-8 grid grid-cols-2 gap-4">
              <div className="flex items-center gap-3 rounded-xl bg-neutral-50 p-4 border border-neutral-200">
                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-[#d4af37]/10">
                  <Award className="h-5 w-5 text-[#d4af37]" />
                </div>
                <div>
                  <p className="font-semibold text-neutral-800">Experiencia</p>
                  <p className="text-sm text-neutral-500">Profesionales certificados</p>
                </div>
              </div>
              <div className="flex items-center gap-3 rounded-xl bg-neutral-50 p-4 border border-neutral-200">
                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-[#d4af37]/10">
                  <Heart className="h-5 w-5 text-[#d4af37]" />
                </div>
                <div>
                  <p className="font-semibold text-neutral-800">Dedicación</p>
                  <p className="text-sm text-neutral-500">Atención personalizada</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
